import { Check } from 'lucide-react';
import React from 'react';
import { Row, Col } from 'reactstrap';
// import { Check } from "react-feather"; // librería de íconos liviana

interface StepperProps {
  currentStep: number;
  steps: string[];
  title?: string;
}

const Stepper: React.FC<StepperProps> = ({ currentStep, steps, title }) => {
  const activeStepLabel = steps[currentStep - 1];
  const isFinished = currentStep > steps.length;

  return (
    <Row style={{ marginTop: 30 }} className="mb-4 justify-content-center">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isCompleted = currentStep > stepNumber;

        return (
          <Col key={label} className="d-flex align-items-center px-0" sm="auto">
            <div
              className={`rounded-circle d-flex align-items-center justify-content-center 
                ${
          isActive || isCompleted
            ? 'bg-primary text-white'
            : 'bg-white text-primary'
          }`}
              style={{
                width: 32,
                height: 32,
                border: '2px solid #A437E7',
                fontWeight: 'bold',
              }}
            >
              {isCompleted ? <Check /> : stepNumber}
            </div>

            {/* Línea (excepto último paso) */}
            {index !== steps.length - 1 && (
              <div
                style={{
                  height: 2,
                  width: 40,
                  backgroundColor: isCompleted ? '#A437E7' : '#ddd',
                }}
              />
            )}
          </Col>
        );
      })}

      {/* Título */}
      {!isFinished && (
        <Row className="justify-content-center mt-3">
          <Col sm="auto">
            <p
              style={{
                fontSize: '24px',
                fontWeight: '600',
                fontStyle: 'medium',
                marginBottom: -1,
              }}
            >
              {title}
            </p>
          </Col>
        </Row>
      )}

      {/* Nombre del step activo */}
      {!isFinished && (
        <Row className="justify-content-center">
          <Col sm="auto" className="text-center px-0 mt-3">
            <span
              style={{
                fontSize: '1rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '1px',
              }}
            >
              {activeStepLabel}
            </span>
          </Col>
        </Row>
      )}
    </Row>
  );
};

export default Stepper;
